import React from 'react';
import {components} from 'react-select';
import type {ControlProps, GroupBase} from 'react-select';
import {SelectOption} from '@chekin/core';
import {FieldErrorMessage} from '@chekinapp/ui';
import {SearchIcon, Wrapper} from './styled';
import {Fieldset} from '../../Fieldset';
import type {SelectProps} from '../types';

const SelectControl = <T, V, L>(
  props: ControlProps<SelectOption<T, V, L>, false, GroupBase<SelectOption<T, V, L>>>,
) => {
  const selectProps = props.selectProps as unknown as SelectProps<T, V, L>;
  const {label, name, error, isDisabled, clearValue, forcedSearchMode, hideControl} = selectProps;
  const isSearchableMode =
    (props.isFocused && selectProps.isSearchable) || forcedSearchMode;

  const leftIconElement = isSearchableMode ? (
    <SearchIcon
      name="magnifierGray"
      color="#9F9FBF"
      className="select__search-icon"
      size="22px"
    />
  ) : (
    selectProps.leftIcon
  );

  const hasValue = props.getValue().length > 0;

  if (hideControl) return null;

  return (
    <Wrapper
      tabIndex={0}
      className="select__control-wrapper"
      // invalid={invalid || Boolean(error)}
      $disabled={isDisabled}
      $hasValue={hasValue}
      $isFocused={props.isFocused}
      onClick={() => {
        if (props.getValue().length > 0) {
          if (clearValue && name) {
            clearValue(name);
          }
        }
      }}
    >
      <components.Control
        {...props}
        className="kiosko:!h-input kiosko:text-kiosko-s kiosko:!pl-3"
      >
        {leftIconElement}
        {props.children}
        <Fieldset
          label={label}
          invalid={!!error}
          isFocused={props.isFocused}
          isEmpty={selectProps?.empty}
          isActivated={!selectProps?.empty || props.isFocused}
        />
      </components.Control>
      {error && (
        <FieldErrorMessage
          className="error-message kiosko:text-kiosko-xs kiosko:bottom-[-44px]"
          data-testid={`${name}-error`}
        >
          {error as string}
        </FieldErrorMessage>
      )}
    </Wrapper>
  );
};

export {SelectControl};
